import React, { useState } from "react";
import { Button, Card, Spinner, ProgressBar } from "react-bootstrap";
import { Check, X } from "lucide-react";

const FloatingIndicator = ({
  show = true,
  status = null,
  description = null,
  percentage = null,
}) => {
  const [expanded, setExpanded] = useState(true);

  if (!show) return null;
  return (
    <div
      className={`floating-cart-container ${expanded ? "show" : "minimized"}`}
    >
      {expanded ? (
        <Card
          style={{
            backgroundColor: "#042742",
            opacity: "0.9",
            color: "#fff",
            borderRadius: "15px",
            position: "relative",
            zIndex: 9999,
            width: "300px",
          }}
        >
          {/* Collapse (X) Button */}
          <Button
            className="collapse-button"
            onClick={() => setExpanded(false)}
            aria-label="Close"
          >
            <X size={20} />
          </Button>

          <Card.Body>
            <Card.Title style={{ fontSize: "1rem", color: "#fff" }}>
              Import Progress
            </Card.Title>

            {status !== "done" && (
              <>
                <div style={{ marginBottom: "10px" }}>{description}</div>

                <ProgressBar
                  now={percentage}
                  label={`${percentage}%`}
                  variant="info"
                  style={{ height: "20px" }}
                />

                <div className="text-end mt-2" style={{ fontSize: "0.8rem" }}>
                  Status: {status}
                </div>
              </>
            )}
            {status === "done" && (
              <div className="d-flex align-items-center gap-2 text-success fw-medium">
                <Check size={20} strokeWidth={2.5} className="text-success" />
                <span>Your import is complete</span>
              </div>
            )}
          </Card.Body>
        </Card>
      ) : (
        <Button
          className="floating-cart-button"
          onClick={() => setExpanded(true)}
          aria-label="Open Import Status"
          variant="primary"
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            zIndex: 9999,
            "--dynamic-bg-color": "#042742",
            border: "none",
          }}
        >
          <Spinner
            size="sm"
            animation="border"
            variant="primary"
            style={{
              "--dynamic-spinner-color": "#fff",
            }}
          />
        </Button>
      )}
    </div>
  );
};

export default FloatingIndicator;
